/**
 * @desc 分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.SysGlobalParamResponseDto>
>;
export function request(
  params: API.basics.sysGlobalParam.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/sysGlobalParam/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
